// extracted by mini-css-extract-plugin
module.exports = {"buttonRow":"toolbar-design-system_buttonRow__9iNcV","stack":"toolbar-design-system_stack__dIDQC"};